module.exports = __webpack_public_path__ + "static/media/education.784e7cf6.svg";